// Libs
import React from 'react';

// Components
import CountButton from '../../Button/CountButton';
import Button from '../../Button';

// Hooks
import useSaveForLater from '../../../pages/Cart/hooks/useSaveForLater';

// Utils
import isDigitalAsset from '../../../utils/isDigitalAsset';

// Styles
import { useStyles } from './LaterProductQtyButtonsStyles';

const LaterProductQtyButtons = ({ nums, ...props }) => {
  const { product, className, detailsMode, isMobileMode } = props;
  const { putFromLaterInCart } = useSaveForLater();
  const { classes, cx } = useStyles({ detailsMode });
  const isDigitalAssetProduct = isDigitalAsset(product);

  return (
    <div className={cx(classes.container, className)}>
      {(detailsMode || (!detailsMode && !isMobileMode)) && (
        <CountButton
          product={product}
          count={nums}
          active={false}
          disabled={true}
          className={classes.countButton}
        />
      )}
      {!detailsMode && (
        <Button
          id="add-to-cart"
          onClick={() =>
            putFromLaterInCart(props.product, isDigitalAssetProduct ? 1 : nums)
          }
          disabled={
            !isDigitalAssetProduct && product?.product_available_qty < 1
          }
          className={classes.addToCartButton}>
          Add To Cart
        </Button>
      )}
    </div>
  );
};

export default LaterProductQtyButtons;
